import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b514ccec = () => interopDefault(import('..\\..\\..\\pages\\admin\\index.vue' /* webpackChunkName: "pages/admin/index" */))
const _2b694ad9 = () => interopDefault(import('..\\..\\..\\pages\\blog\\index.vue' /* webpackChunkName: "pages/blog/index" */))
const _15873c55 = () => interopDefault(import('..\\..\\..\\pages\\index-old.vue' /* webpackChunkName: "pages/index-old" */))
const _41704894 = () => interopDefault(import('..\\..\\..\\pages\\account\\cart.vue' /* webpackChunkName: "pages/account/cart" */))
const _4e9163b1 = () => interopDefault(import('..\\..\\..\\pages\\account\\cart-for-later.vue' /* webpackChunkName: "pages/account/cart-for-later" */))
const _ab12ae58 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\index.vue' /* webpackChunkName: "pages/account/dashboard/index" */))
const _5717dd42 = () => interopDefault(import('..\\..\\..\\pages\\account\\forgot-password.vue' /* webpackChunkName: "pages/account/forgot-password" */))
const _cdb1717a = () => interopDefault(import('..\\..\\..\\pages\\account\\login.vue' /* webpackChunkName: "pages/account/login" */))
const _602ee6b9 = () => interopDefault(import('..\\..\\..\\pages\\account\\register.vue' /* webpackChunkName: "pages/account/register" */))
const _1afa6aec = () => interopDefault(import('..\\..\\..\\pages\\landing\\new-home.vue' /* webpackChunkName: "pages/landing/new-home" */))
const _e0b23932 = () => interopDefault(import('..\\..\\..\\pages\\landing\\pay-balance.vue' /* webpackChunkName: "pages/landing/pay-balance" */))
const _1909fe71 = () => interopDefault(import('..\\..\\..\\pages\\order\\cancel.vue' /* webpackChunkName: "pages/order/cancel" */))
const _1cea9a9c = () => interopDefault(import('..\\..\\..\\pages\\order\\success.vue' /* webpackChunkName: "pages/order/success" */))
const _d5a86fd2 = () => interopDefault(import('..\\..\\..\\pages\\pages\\400.vue' /* webpackChunkName: "pages/pages/400" */))
const _d58c40d0 = () => interopDefault(import('..\\..\\..\\pages\\pages\\401.vue' /* webpackChunkName: "pages/pages/401" */))
const _d537b3ca = () => interopDefault(import('..\\..\\..\\pages\\pages\\404.vue' /* webpackChunkName: "pages/pages/404" */))
const _7b59110b = () => interopDefault(import('..\\..\\..\\pages\\pages\\about-us.vue' /* webpackChunkName: "pages/pages/about-us" */))
const _4d7e6439 = () => interopDefault(import('..\\..\\..\\pages\\pages\\brands.vue' /* webpackChunkName: "pages/pages/brands" */))
const _725c39a7 = () => interopDefault(import('..\\..\\..\\pages\\pages\\catalogs.vue' /* webpackChunkName: "pages/pages/catalogs" */))
const _c30fe1ac = () => interopDefault(import('..\\..\\..\\pages\\pages\\coming-soon.vue' /* webpackChunkName: "pages/pages/coming-soon" */))
const _0c2a03d8 = () => interopDefault(import('..\\..\\..\\pages\\pages\\contact-us.vue' /* webpackChunkName: "pages/pages/contact-us" */))
const _5379b06c = () => interopDefault(import('..\\..\\..\\pages\\pages\\dropshipping.vue' /* webpackChunkName: "pages/pages/dropshipping" */))
const _049b65aa = () => interopDefault(import('..\\..\\..\\pages\\pages\\fajas-colombianas-wholesale-sign-up.vue' /* webpackChunkName: "pages/pages/fajas-colombianas-wholesale-sign-up" */))
const _4154c8f9 = () => interopDefault(import('..\\..\\..\\pages\\pages\\faq.vue' /* webpackChunkName: "pages/pages/faq" */))
const _338e4da9 = () => interopDefault(import('..\\..\\..\\pages\\pages\\how-does-it-work.vue' /* webpackChunkName: "pages/pages/how-does-it-work" */))
const _a7621ab4 = () => interopDefault(import('..\\..\\..\\pages\\pages\\jeans-colombianos-wholesale-sign-up.vue' /* webpackChunkName: "pages/pages/jeans-colombianos-wholesale-sign-up" */))
const _20296b0a = () => interopDefault(import('..\\..\\..\\pages\\pages\\minimum-advertised-price-policy.vue' /* webpackChunkName: "pages/pages/minimum-advertised-price-policy" */))
const _7c3f41f8 = () => interopDefault(import('..\\..\\..\\pages\\pages\\privacy-policy.vue' /* webpackChunkName: "pages/pages/privacy-policy" */))
const _19833ade = () => interopDefault(import('..\\..\\..\\pages\\pages\\products.vue' /* webpackChunkName: "pages/pages/products" */))
const _00d5ab26 = () => interopDefault(import('..\\..\\..\\pages\\pages\\returns.vue' /* webpackChunkName: "pages/pages/returns" */))
const _459b94b2 = () => interopDefault(import('..\\..\\..\\pages\\pages\\shipping-policies.vue' /* webpackChunkName: "pages/pages/shipping-policies" */))
const _b23cf9be = () => interopDefault(import('..\\..\\..\\pages\\pages\\terms-and-conditions.vue' /* webpackChunkName: "pages/pages/terms-and-conditions" */))
const _7f0262ff = () => interopDefault(import('..\\..\\..\\pages\\pages\\wellcome.vue' /* webpackChunkName: "pages/pages/wellcome" */))
const _0bd9c854 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\address-directory.vue' /* webpackChunkName: "pages/account/dashboard/address-directory" */))
const _8df1ea62 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\affiliate.vue' /* webpackChunkName: "pages/account/dashboard/affiliate" */))
const _0b7e452c = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\affiliate-commissions.vue' /* webpackChunkName: "pages/account/dashboard/affiliate-commissions" */))
const _b4882e4a = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\buy-again.vue' /* webpackChunkName: "pages/account/dashboard/buy-again" */))
const _292b7ecc = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\change-password.vue' /* webpackChunkName: "pages/account/dashboard/change-password" */))
const _77055f4a = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\preorders.vue' /* webpackChunkName: "pages/account/dashboard/preorders" */))
const _fe160fd2 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\price-catalog.vue' /* webpackChunkName: "pages/account/dashboard/price-catalog" */))
const _1ed0ed2e = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\sales-executive.vue' /* webpackChunkName: "pages/account/dashboard/sales-executive" */))
const _0ef68bfe = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\your-account.vue' /* webpackChunkName: "pages/account/dashboard/your-account" */))
const _136257c1 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\your-orders.vue' /* webpackChunkName: "pages/account/dashboard/your-orders" */))
const _753ae943 = () => interopDefault(import('..\\..\\..\\pages\\account\\dashboard\\your-statement.vue' /* webpackChunkName: "pages/account/dashboard/your-statement" */))
const _7be5000a = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _601b9151 = () => interopDefault(import('..\\..\\..\\pages\\balance\\payments\\_type\\cancel.vue' /* webpackChunkName: "pages/balance/payments/_type/cancel" */))
const _8fe93888 = () => interopDefault(import('..\\..\\..\\pages\\balance\\payments\\_type\\success.vue' /* webpackChunkName: "pages/balance/payments/_type/success" */))
const _1734e442 = () => interopDefault(import('..\\..\\..\\pages\\order\\payments\\_type\\cancel.vue' /* webpackChunkName: "pages/order/payments/_type/cancel" */))
const _a5fe0e24 = () => interopDefault(import('..\\..\\..\\pages\\order\\payments\\_type\\success.vue' /* webpackChunkName: "pages/order/payments/_type/success" */))
const _9e28283c = () => interopDefault(import('..\\..\\..\\pages\\agents\\_handle.vue' /* webpackChunkName: "pages/agents/_handle" */))
const _c71029e4 = () => interopDefault(import('..\\..\\..\\pages\\blog\\_handle.vue' /* webpackChunkName: "pages/blog/_handle" */))
const _252851fc = () => interopDefault(import('..\\..\\..\\pages\\checkout\\_type.vue' /* webpackChunkName: "pages/checkout/_type" */))
const _42362c8e = () => interopDefault(import('..\\..\\..\\pages\\collections\\_handle.vue' /* webpackChunkName: "pages/collections/_handle" */))
const _5bf8040c = () => interopDefault(import('..\\..\\..\\pages\\products\\_handle.vue' /* webpackChunkName: "pages/products/_handle" */))
const _1e5f247c = () => interopDefault(import('..\\..\\..\\pages\\collections\\_handleCollection\\products\\_handle.vue' /* webpackChunkName: "pages/collections/_handleCollection/products/_handle" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/admin",
    component: _b514ccec,
    name: "admin"
  }, {
    path: "/blog",
    component: _2b694ad9,
    name: "blog"
  }, {
    path: "/index-old",
    component: _15873c55,
    name: "index-old"
  }, {
    path: "/account/cart",
    component: _41704894,
    name: "account-cart"
  }, {
    path: "/account/cart-for-later",
    component: _4e9163b1,
    name: "account-cart-for-later"
  }, {
    path: "/account/dashboard",
    component: _ab12ae58,
    name: "account-dashboard"
  }, {
    path: "/account/forgot-password",
    component: _5717dd42,
    name: "account-forgot-password"
  }, {
    path: "/account/login",
    component: _cdb1717a,
    name: "account-login"
  }, {
    path: "/account/register",
    component: _602ee6b9,
    name: "account-register"
  }, {
    path: "/landing/new-home",
    component: _1afa6aec,
    name: "landing-new-home"
  }, {
    path: "/landing/pay-balance",
    component: _e0b23932,
    name: "landing-pay-balance"
  }, {
    path: "/order/cancel",
    component: _1909fe71,
    name: "order-cancel"
  }, {
    path: "/order/success",
    component: _1cea9a9c,
    name: "order-success"
  }, {
    path: "/pages/400",
    component: _d5a86fd2,
    name: "pages-400"
  }, {
    path: "/pages/401",
    component: _d58c40d0,
    name: "pages-401"
  }, {
    path: "/pages/404",
    component: _d537b3ca,
    name: "pages-404"
  }, {
    path: "/pages/about-us",
    component: _7b59110b,
    name: "pages-about-us"
  }, {
    path: "/pages/brands",
    component: _4d7e6439,
    name: "pages-brands"
  }, {
    path: "/pages/catalogs",
    component: _725c39a7,
    name: "pages-catalogs"
  }, {
    path: "/pages/coming-soon",
    component: _c30fe1ac,
    name: "pages-coming-soon"
  }, {
    path: "/pages/contact-us",
    component: _0c2a03d8,
    name: "pages-contact-us"
  }, {
    path: "/pages/dropshipping",
    component: _5379b06c,
    name: "pages-dropshipping"
  }, {
    path: "/pages/fajas-colombianas-wholesale-sign-up",
    component: _049b65aa,
    name: "pages-fajas-colombianas-wholesale-sign-up"
  }, {
    path: "/pages/faq",
    component: _4154c8f9,
    name: "pages-faq"
  }, {
    path: "/pages/how-does-it-work",
    component: _338e4da9,
    name: "pages-how-does-it-work"
  }, {
    path: "/pages/jeans-colombianos-wholesale-sign-up",
    component: _a7621ab4,
    name: "pages-jeans-colombianos-wholesale-sign-up"
  }, {
    path: "/pages/minimum-advertised-price-policy",
    component: _20296b0a,
    name: "pages-minimum-advertised-price-policy"
  }, {
    path: "/pages/privacy-policy",
    component: _7c3f41f8,
    name: "pages-privacy-policy"
  }, {
    path: "/pages/products",
    component: _19833ade,
    name: "pages-products"
  }, {
    path: "/pages/returns",
    component: _00d5ab26,
    name: "pages-returns"
  }, {
    path: "/pages/shipping-policies",
    component: _459b94b2,
    name: "pages-shipping-policies"
  }, {
    path: "/pages/terms-and-conditions",
    component: _b23cf9be,
    name: "pages-terms-and-conditions"
  }, {
    path: "/pages/wellcome",
    component: _7f0262ff,
    name: "pages-wellcome"
  }, {
    path: "/account/dashboard/address-directory",
    component: _0bd9c854,
    name: "account-dashboard-address-directory"
  }, {
    path: "/account/dashboard/affiliate",
    component: _8df1ea62,
    name: "account-dashboard-affiliate"
  }, {
    path: "/account/dashboard/affiliate-commissions",
    component: _0b7e452c,
    name: "account-dashboard-affiliate-commissions"
  }, {
    path: "/account/dashboard/buy-again",
    component: _b4882e4a,
    name: "account-dashboard-buy-again"
  }, {
    path: "/account/dashboard/change-password",
    component: _292b7ecc,
    name: "account-dashboard-change-password"
  }, {
    path: "/account/dashboard/preorders",
    component: _77055f4a,
    name: "account-dashboard-preorders"
  }, {
    path: "/account/dashboard/price-catalog",
    component: _fe160fd2,
    name: "account-dashboard-price-catalog"
  }, {
    path: "/account/dashboard/sales-executive",
    component: _1ed0ed2e,
    name: "account-dashboard-sales-executive"
  }, {
    path: "/account/dashboard/your-account",
    component: _0ef68bfe,
    name: "account-dashboard-your-account"
  }, {
    path: "/account/dashboard/your-orders",
    component: _136257c1,
    name: "account-dashboard-your-orders"
  }, {
    path: "/account/dashboard/your-statement",
    component: _753ae943,
    name: "account-dashboard-your-statement"
  }, {
    path: "/",
    component: _7be5000a,
    name: "index"
  }, {
    path: "/balance/payments/:type?/cancel",
    component: _601b9151,
    name: "balance-payments-type-cancel"
  }, {
    path: "/balance/payments/:type?/success",
    component: _8fe93888,
    name: "balance-payments-type-success"
  }, {
    path: "/order/payments/:type?/cancel",
    component: _1734e442,
    name: "order-payments-type-cancel"
  }, {
    path: "/order/payments/:type?/success",
    component: _a5fe0e24,
    name: "order-payments-type-success"
  }, {
    path: "/agents/:handle?",
    component: _9e28283c,
    name: "agents-handle"
  }, {
    path: "/blog/:handle",
    component: _c71029e4,
    name: "blog-handle"
  }, {
    path: "/checkout/:type?",
    component: _252851fc,
    name: "checkout-type"
  }, {
    path: "/collections/:handle?",
    component: _42362c8e,
    name: "collections-handle"
  }, {
    path: "/products/:handle?",
    component: _5bf8040c,
    name: "products-handle"
  }, {
    path: "/collections/:handleCollection?/products/:handle?",
    component: _1e5f247c,
    name: "collections-handleCollection-products-handle"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
